<template>
  <div class="content">
    <div class="inner">
      <div class="selector">
        <select
          name="filterdropdown"
          v-model="selectedCategory"
        >
          <option
            value="all"
            selected
          >Összes</option>
          <option
            v-for="(item, key) in filterOptions"
            :key="key"
            v-bind:value="item"
          >{{item}}</option>
        </select>
      </div>
      <div class="filteredlist">
        <div
          v-for="(item, key) in filteredItems"
          :key="key"
          :class="'item '+item[1].slug"
        >
          <router-link
            class="filteredlink"
            :to="'/shop/'+item[1].slug"
            @click.native="scrollToElement()"
          ><img
              :src="'./shops/'+item[1].slug+'.png'"
              :alt="item[0]"
            ></router-link>
        </div>
      </div>
      <div class="shoplist">
        <div class="left-col">
          <div
            v-for="(item, key) in cardsFirst"
            :key="key"
            :class="{'listitem boxed': !item[1].szoveg, 'listitem': item[1].szoveg}"
          >
            <div
              :class="'barbershop no'+(key+1)"
              :data-slug="item[1].slug"
            >
              <div class="logocont">
                <img
                  :src="'./shops/'+item[1].slug+'.png'"
                  :alt="item[0]"
                >
              </div>
              <div class="city">{{item[1].város}}</div>
              <div class="shopname">{{item[0]}}</div>
              <div class="addressline">
                <div class="address">#{{item[1].cím}}</div>
                <a
                  :title="'Facebook oldal'"
                  :href="item[1].face"
                  target="_blank"
                  v-if="item[1].face"
                ><img
                    class="facebook"
                    src="../assets/facebook-icon-blue.svg"
                    alt="Facebook oldal"
                  ></a>
                <a
                  :title="'Weboldal felkeresése'"
                  :href="item[1].web"
                  target="_blank"
                  v-if="item[1].web"
                ><img
                    class="website"
                    src="../assets/website-icon.svg"
                    alt="Weboldal"
                  ></a>
              </div>
              <div
                class="separatordots"
                v-if="item[1].szoveg"
              >
              </div>
              <div
                class="description"
                v-if="item[1].szoveg"
              >
                {{item[1].szoveg}}
              </div>
            </div>
            <div
              class="hungariaspons"
              v-if="key === 10 ||key === 20"
            >
              <a
                href="http://www.facebook.com/hungariaextradry"
                target="_blank"
              ><img src="../assets/hungaria-bottle.png"></a>
            </div>
            <div
              class="hungariaspons"
              v-if="key === 5 || key === 15"
            >
              <a
                href="http://www.instagram.com/hungariapezsgo"
                target="_blank"
              ><img src="../assets/hungaria-bottle.png"></a>
            </div>
            <div
              class="history"
              v-if="key === 5 || key === 10 || key === 15 || key === 20"
            >
              <div class="historytitle">
                Borbély történelem
              </div>
              <div class="separatordots"></div>
              <div
                class="description"
                v-if="key === 5"
              >
                Borbélyok már az ókorban is voltak. Igaz, sokkal szerteágazóbb volt a feladatuk,
                mint mai utódaiknak. Nem csak beretváltak, de sebeket gyógyítottak, fogakat húztak.
                A császárkori Rómában komoly megbecsülésnek örvendtek,
                ám a birodalom bukásával az ő mesterségük is feledésbe merült egy időre.
              </div>
              <div
                class="description"
                v-if="key === 10"
              >
                Egészen a XIII. századig kellett várniuk, hogy újra a mindennapok
                részesei lehessenek. Sőt, megmaradt az a feladatuk is, hogy a kliens
                hajának levágása és arcának megborotválása mellett ismét az akkori viszonyok
                között kicsit furcsán hangzó „gyógyítást” is ők végezték. Illetve, mondjuk
                úgy, a bizonyos fogásokat rémisztőnek és megalázónak tekintő orvosok helyett
                a sebészeti beavatkozások többségét is ők csinálták. Az orvosok ódzkodásának
                volt némi alapja, mivel a borbélyok érzéstelenítés nélkül voltak kénytelenek fogakat
                húzni, végtagokat amputálni, eret vágni vagy beöntést adni.
              </div>
              <div
                class="description"
                v-if="key === 15"
              >
                Magyarországon szerzetesek voltak az első borbélyok.
                Amikor azonban IX. Gergely pápa eltiltotta a papokat a
                vérontással járó segítségnyújtástól, ismét a világiak vették át a szerepüket.
                A XIII. században alakultak ki az első borbélyműhelyek, sőt részt vettek a
                királyi udvartartásban is.
              </div>
              <div
                class="description"
                v-if="key === 20"
              >
                Maga Mátyás király is nagyra értékelte a mesterséget, Budán tervezett
                egyetemén a borbélytudomány számára egy külön szobát akart berendezni.
                Persze itt is hozzá kell tenni, hogy nem a nyírás és beretválás miatt
                tartották őket nagy becsben, hanem a már említett „orvosi” beavatkozásokban való
                jártasságuk okán. Az 1700-as évek végére vált ketté végleg a borbélymesterség
                és az orvostudomány, és itt egy kicsit meg is bicsaklott volna a mesterség,
                ha nem jön divatba a jólfésültség itthon is.
              </div>
            </div>
          </div>
        </div>
        <div class="right-col">
          <div
            v-for="(item, key) in cardsSecond"
            :key="key"
            :class="{'listitem boxed': !item[1].szoveg, 'listitem': item[1].szoveg}"
          >
            <div
              :class="'barbershop no'+(key+1)"
              :data-slug="item[1].slug"
            >
              <div class="logocont">
                <img
                  :src="'./shops/'+item[1].slug+'.png'"
                  :alt="item[0]"
                >
              </div>
              <div class="city">{{item[1].város}}</div>
              <div class="shopname">{{item[0]}}</div>
              <div class="addressline">
                <div class="address">#{{item[1].cím}}</div>
                <a
                  :title="'Facebook oldal'"
                  :href="item[1].face"
                  target="_blank"
                  v-if="item[1].face"
                ><img
                    class="facebook"
                    src="../assets/facebook-icon-blue.svg"
                    alt="Facebook oldal"
                  ></a>
                <a
                  :title="'Weboldal felkeresése'"
                  :href="item[1].web"
                  target="_blank"
                  v-if="item[1].web"
                ><img
                    class="website"
                    src="../assets/website-icon.svg"
                    alt="Weboldal"
                  ></a>
              </div>
              <div
                class="separatordots"
                v-if="item[1].szoveg"
              >
              </div>
              <div
                class="description"
                v-if="item[1].szoveg"
              >
                {{item[1].szoveg}}
              </div>
            </div>
            <div
              class="hungariaspons"
              v-if="key === 7 ||key === 17"
            >
              <a
                href="http://www.instagram.com/hungariapezsgo"
                target="_blank"
              ><img src="../assets/hungaria-bottle.png"></a>
            </div>
            <div
              class="hungariaspons"
              v-if="key === 2 || key === 12 || key === 22"
            >
              <a
                href="http://www.facebook.com/hungariaextradry"
                target="_blank"
              ><img src="../assets/hungaria-bottle.png"></a>
            </div>
            <div
              class="history"
              v-if="key === 2 || key === 7 || key === 12 || key === 17 || key === 22"
            >
              <div class="historytitle">
                Borbély történelem
              </div>
              <div class="separatordots"></div>
              <div
                class="description"
                v-if="key === 2"
              >
                Az 1700-as évek végére emberek egyre nagyobb gondot fordítottak megjelenésükre.
                Ahogy Faludi fogalmazta, „fodorították” hajukat, így a borbélyok
                (nyelvújítási szóval) fodrászok is lettek. Kialakult a mai tevékenységi körük: a
                borbély hajat nyír és borotvál, a fodrász pedig frizurát készít.
              </div>
              <div
                class="description"
                v-if="key === 7"
              >
                A századfordulón már nemcsak egy gyors borotválásra ugrottak be a kuncsaftok
                a szalonokba, hanem kockáztak, dominóztak is ott, egyfajta klubként működtek
                az ilyen helyek. Sőt, akár üzletek is itt születtek. És ez – hogy ugorjunk egy
                nagyot az időben – egészen a második világháború utánig ki is tartott.
              </div>
              <div
                class="description"
                v-if="key === 12"
              >
                1945 után az állam kispolgári dekadenciának minősítette a borbélyszalonokba
                járást, és szépen kikoptak a vendégek is. A szakmát egyszerűen férfifodrászatra
                keresztelték, és a klasszikus szalonok szinte egy csapásra eltűntek.
              </div>
              <div
                class="description"
                v-if="key === 17"
              >
                A hosszú álomból 2011-ben kezdett ébredezni a borbélyság. Ekkor nyitotta első,
                klasszikus üzletét Deák Zoltán. Utólag azt nyilatkozta: akkori kudarcának talán
                az is volt az oka, hogy az első üzletet a Metropolitanban nyitotta, amelynek a fő
                profilja a ruhakereskedés volt, és ez nem bizonyult szerencsés választásnak.
              </div>
              <div
                class="description"
                v-if="key === 22"
              >
                A Gellei testvérek, már olyan üzletet nyitottak, amiben csakis ez a szolgáltatás
                kapott helyet, és ez jó húzás volt. Ez lett a Budapest Barber Shop. Az ő sikerükön
                felbuzdulva nyílik most sorban a többi üzlet is. Az érdeklődést azonban nem, vagy
                nem csak ők generálták, „a borbélykodás mindenképpen beszivárgott volna az országba,
                ugyanis világszerte dívik a hipszter-őrület, a borosta, a szakáll.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'ContentComponent',
  data() {
    return {
      selectedCategory: 'all',
    };
  },
  methods: {
    scrollToElement() {
      const element = document.querySelector(`[data-slug=${this.$route.params.slug}]`);
      const hashpart = window.location.hash.replace('#/shop/', '');
      if (this.$route.params.slug === hashpart) {
        if (element) {
          const ua = window.navigator.userAgent;
          const msie = ua.indexOf('MSIE ');
          // If Internet Explorer, return version number
          if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
            setTimeout(() => {
              window.scroll(0, element.offsetTop - 130);
            }, 1000);
          }

          window.scrollTo({
            behavior: 'smooth',
            left: 0,
            top: element.offsetTop - 130,
          });
          setTimeout(() => {
            element.classList.toggle('current');
          }, 1500);
          setTimeout(() => {
            element.classList.toggle('current');
          }, 2500);
        }
      }
    },
  },
  mounted() {
  },
  computed: {
    ...mapState(['items']),
    filterOptions() {
      const allOptions = Object.entries(this.items);
      const options = [];
      for (let index = 0; index < allOptions.length; index += 1) {
        options.push(allOptions[index][1].megye);
      }
      const uniqueOptions = [...new Set(options)];
      return uniqueOptions.sort();
    },
    filteredItems() {
      // make an array of vuex items
      const filter = Object.entries(this.items);
      const megyeSelected = this.selectedCategory;

      // store the filtered values
      const filtered = [];

      if (megyeSelected === 'all') {
        return filter;
      }
      // if filter is set loop through the filter array
      for (let index = 0; index < filter.length; index += 1) {
        if (filter[index][1].megye === megyeSelected) {
          filtered.push(filter[index]);
        }
      }
      return filtered;
    },
    cardsFirst() {
      const allOptions = Object.entries(this.items);
      return allOptions.splice(0, 25);
    },
    cardsSecond() {
      const allOptions = Object.entries(this.items);
      return allOptions.splice(25, 24);
    },
  },
};
</script>

<style scoped lang="css">
.content {
  background-color: #1d151c;
}
.inner {
  padding: 30px 15px 30px 15px;
}
.selector {
  color: #fff;
  font-size: 24px;
  display: flex;
  flex-wrap: wrap;
  max-width: 650px;
  margin: 20px 40px 20px auto;
  align-items: center;
  justify-content: flex-end;
}
select {
  background-color: transparent;
  color: #fff;
  text-transform: uppercase;
  border-radius: 6px;
  padding: 12px 20px;
  letter-spacing: 2px;
  font-size: 14px;
  width: 300px;
}
select:active,
select:focus {
  outline: none;
}
option {
  color: #fff;
  background-color: #1d151c;
  letter-spacing: 2px;
}
.filteredlist {
  display: flex;
  flex-wrap: wrap;
}
.filteredlist .item {
  width: 130px;
  cursor: pointer;
}
.filteredlist .item img {
  width: 100%;
  height: auto;
}
.filteredlist .item:hover {
  background-color: #373038;
}
.shoplist {
  display: grid;
  grid-template-columns: 50% 50%;
  display: -ms-grid;
  -ms-grid-columns: 50% 50%;
}
.listitem {
}
.left-col {
  padding-top: 100px;
  grid-column: 1/2;
  -ms-grid-column: 1;
}
.right-col {
  grid-column: 2/3;
  -ms-grid-column: 2;
}
.hungariaspons {
  margin-top: -60px;
  margin-bottom: 25px;
  text-align: center;
}
.hungariaspons a {
  display: block;
  width: fit-content;
  margin: 20px auto 0 auto;
}
.barbershop {
  background-color: #fff;
  border-radius: 20px;
  padding: 35px 40px;
  height: fit-content;
  transition: all 1s;
  position: relative;
  margin: 35px 35px 90px 35px;
}
.shopname {
  font-family: "Minion Pro";
  font-size: 40px;
  line-height: 1;
  max-width: calc(100% - 90px);
}
.city {
  font-family: "Blacksword";
  color: #d13138;
  font-size: 43px;
  line-height: 1;
  margin-bottom: -7px;
}
.logocont {
  background-color: #1d151c;
  border-radius: 50%;
  overflow: hidden;
  width: 150px;
  height: 150px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  right: 15px;
  top: -65px;
}
.logocont img {
  width: 130px;
  height: 130px;
}
.addressline {
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  width: 100%;
}
.addressline a {
  width: fit-content;
  margin: 0 10px;
}
.separatordots {
  width: calc(100% - 4px);
  height: 15px;
  background-image: url(../assets/sep-dot.svg);
  background-repeat: repeat-x;
  background-position: left center;
  background-size: 8px;
  margin: 10px 0;
}
.address {
  font-family: "Gotham Book";
  font-size: 16px;
  width: calc(100% - 80px);
}
.facebook,
.website {
  height: 23px;
}
.description {
  font-family: "Gotham Book";
  font-size: 15px;
  background-image: url(../assets/description-bg.png);
  background-repeat: no-repeat;
  background-position: center;
}
.history {
  background-color: #238eb6;
  border-radius: 20px;
  padding: 35px 40px;
  height: fit-content;
  position: relative;
  margin: 0 35px 90px 35px;
}
.history .description {
  color: #fff;
}
.historytitle {
  font-family: "Blacksword";
  color: #fff;
  font-size: 43px;
  line-height: 1;
}
.history .separatordots {
  background-image: url(../assets/sep-dot-w.svg);
}
@media screen and (max-width: 1190px) {
  .shoplist {
    grid-template-columns: 100%;
    -ms-grid-columns: 100%;
  }
  .left-col {
    grid-column: 1/2;
    -ms-grid-column: 1;
  }
  .right-col {
    grid-column: 1/2;
    -ms-grid-column: 1;
  }
  .history {
    margin: 0 0 90px 0;
  }
  .barbershop {
    margin: 35px 0 90px 0;
  }
}
@media screen and (max-width: 810px) {
  .hungariaspons img {
    width: 100%;
  }
}
@media screen and (max-width: 767px) {
  .logocont {
    right: -35px;
    top: -80px;
    height: 140px;
    width: 140px;
  }
  .barbershop {
    margin: 35px 0 80px 0;
    padding: 25px;
  }
  .history {
    margin: 0 0 80px 0;
    padding: 25px;
  }
  .shopname {
    max-width: calc(100% - 45px);
  }
  .selector {
    width: 100%;
  }
  select {
    width: 100%;
  }
}
@media screen and (max-width: 450px) {
  .city {
    margin-top: 25px;
    font-size: 40px;
  }
  .shopname {
    font-size: 37px;
    max-width: 100%;
  }
  .logocont {
    right: -40px;
  }
  .historytitle {
    font-size: 40px;
  }
}
@media screen and (max-width: 400px) {
  .city {
    font-size: 35px;
  }
  .shopname {
    font-size: 32px;
  }
  .inner {
    padding: 30px 0px 30px 0px;
  }
  .logocont {
    right: -27px;
  }
  .historytitle {
    font-size: 35px;
  }
}
</style>
